import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";

const NewsPage = lazy(() => import("@/pages/NewsPage"));
const NewsDetailPage = lazy(() => import("@/pages/NewsDetailPage"));
const ArticlesPage = lazy(() => import("@/pages/ArticlesPage"));
const ArticleDetailPage = lazy(() => import("@/pages/ArticleDetailPage"));
const CohortPage = lazy(() => import("@/pages/CohortPage"));
const FoundersAndInvestorsPage = lazy(
  () => import("@/pages/FoundersAndInvestorsPage"),
);
const MentorsPage = lazy(() => import("@/pages/MentorsPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));

const FullscreenLoader = () => (
  <div className="bg-[#050505] text-bone min-h-screen flex items-center justify-center">
    <p className="font-mono text-xs uppercase tracking-[0.2em]">Loading...</p>
  </div>
);

const AppRoutes = () => (
  <Suspense fallback={<FullscreenLoader />}>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/news" element={<NewsPage />} />
      <Route path="/news/:slug" element={<NewsDetailPage />} />
      <Route path="/articles" element={<ArticlesPage />} />
      <Route path="/articles/:slug" element={<ArticleDetailPage />} />
      <Route path="/cohort" element={<CohortPage />} />
      <Route
        path="/founders-investors"
        element={<FoundersAndInvestorsPage />}
      />
      <Route path="/mentors" element={<MentorsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/about" element={<AboutPage />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
